import { createMediaMatcher } from 'react-media-match'

const Size = createMediaMatcher({
  mobile: '(max-width: 767px)',
  xSmall: '(max-width: 419px)',
  tablet: '(max-width: 1279px) and (min-width: 768px)',
  desktop: '(min-width: 1280px)',
})

export default Size
